import { ENV } from "../utils";

export class CiiuActivity {
  baseApi = ENV.BASE_API;

  async getCiiuActivities(accessToken, active = true) {
    const url = `${this.baseApi}/ciiu-activities?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createCiiuActivity(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-ciiu-activity`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateCiiuActivity(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-ciiu-activity/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteCiiuActivity(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-ciiu-activity/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
